exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success--text[data-v-34cc82ca]{color:green}.error--text[data-v-34cc82ca]{color:red}", ""]);

// exports
